import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'conversorBytes'
})
export class ConversorBytesPipe implements PipeTransform {

	private Unidades: any[] = [
		{ Divisor: 1024, Unidad: "Kb" },
		{ Divisor: 1024, Unidad: "Mb" },
		{ Divisor: 1024, Unidad: "Gb" },
		{ Divisor: 1024, Unidad: "Tb" }
	];

	transform(value: number): string {
		if (!value) {
			return "";
		}

		let Aux = 0;
		let Resultado: number = value;

		while (this.Unidades[Aux].Divisor <= Resultado && Aux < this.Unidades.length) {
			//Controlo que el indice no supere la cantidad de elementos.
			if (Aux < this.Unidades.length) {
				Resultado = Resultado / this.Unidades[Aux].Divisor;
				Aux++;
			}
		}

		return Resultado.toFixed(2) + ' ' + this.Unidades[Aux - 1].Unidad;
	}
}